var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{attrs:{"grid-list-xl":"","fluid":""}},[_c('table-payout-address',{attrs:{"coin":"XRP"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }